<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="8"
  >
    <circle
      cx="632.5"
      cy="530.8"
      r="3.5"
      fill="currentColor"
      fill-rule="evenodd"
      transform="translate(-629 -527)"
    />
  </svg>
</template>
